import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { useAuth } from '@/lib/auth'
import { fetchColaboradores, fetchRhKpis } from '@/features/rh/api'
import { Alert, Avatar, Kpi, KpiGrid, Muted, PageHeader, Section, StatusBadge } from '@/components/ui'

export function GestorPage() {
  const { user, canView } = useAuth()

  const kpis = useQuery({
    queryKey: ['gestor', 'kpis'],
    queryFn: fetchRhKpis,
  })

  const equipe = useQuery({
    queryKey: ['gestor', 'equipe'],
    queryFn: () => fetchColaboradores({ status: 'ativo', por_pagina: 50, ordenar: 'nome' }),
  })

  const membros = equipe.data?.dados || []

  return (
    <section className="hi-page">
      <PageHeader
        title="Minha equipe"
        subtitle={`Olá, ${user?.nome || user?.email}. Visão do time sob sua gestão (ou visão RH) via API. Feedbacks, reuniões e avaliações avançadas seguem no legado.`}
        actions={
          <>
            <a className="btn btn-secondary" href={legacyAppUrl('#/gestor')}>
              Hub legado
            </a>
            {canView('reunioes-lideranca') ? (
              <a className="btn btn-primary" href={legacyAppUrl('#/reunioes-lideranca')}>
                Reuniões
              </a>
            ) : null}
          </>
        }
      />

      {kpis.isLoading ? <Muted>Carregando indicadores…</Muted> : null}
      {kpis.isError ? (
        <Alert tone="danger">
          {kpis.error instanceof ApiError ? kpis.error.message : 'Falha ao carregar KPIs.'}
        </Alert>
      ) : null}
      {kpis.data ? (
        <KpiGrid>
          <Kpi label="Headcount (escopo)" value={kpis.data.total.toLocaleString('pt-BR')} />
          <Kpi label="Admissões no mês" value={kpis.data.adm_mes.toLocaleString('pt-BR')} />
          <Kpi label="Em férias" value={kpis.data.em_ferias.toLocaleString('pt-BR')} />
          <Kpi label="Afastados" value={kpis.data.afastados.toLocaleString('pt-BR')} />
          <Kpi label="Aval. pendentes" value={kpis.data.aval_pend.toLocaleString('pt-BR')} />
        </KpiGrid>
      ) : null}

      <Section title={`Equipe (${equipe.data?.meta?.total ?? membros.length})`}>
        {equipe.isLoading ? <Muted>Carregando…</Muted> : null}
        {equipe.isError ? (
          <Alert tone="danger">
            {equipe.error instanceof ApiError ? equipe.error.message : 'Falha ao listar equipe.'}
          </Alert>
        ) : null}
        {membros.length === 0 && !equipe.isLoading ? (
          <Muted>Nenhum colaborador no escopo atual.</Muted>
        ) : (
          <ul className="hi-list">
            {membros.map((c) => {
              const body = (
                <>
                  <Avatar src={c.foto_url || c.foto} nome={c.nome} iniciais={c.iniciais} />
                  <div className="hi-row-main">
                    <strong>{c.nome}</strong>
                    <span>
                      {c.cargo_nome || 'Sem cargo'}
                      {c.departamento_nome ? ` · ${c.departamento_nome}` : ''}
                    </span>
                  </div>
                  <StatusBadge tone={c.status && c.status !== 'ativo' ? 'inativo' : 'ativo'}>
                    {c.status_display || c.status || '-'}
                  </StatusBadge>
                </>
              )
              return (
                <li key={c.id}>
                  {canView('colaboradores') ? (
                    <Link className="card card-interactive hi-row" to={`/app/rh/${c.id}`}>
                      {body}
                    </Link>
                  ) : (
                    <div className="card hi-row">{body}</div>
                  )}
                </li>
              )
            })}
          </ul>
        )}
      </Section>
    </section>
  )
}

export default GestorPage
